// @flow

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import {
  onlyWhenSupport,
  VALID,
  type UserInputValidationError,
  type UserInputValidatorArgs,
} from '@tectonics/prs/validation';

export function voucherCardValidator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, 'vr');
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'mealVoucherVrPreTokenizedCardCvv':
      return onlyWhen('field_vr_pre_tokenized_card_cvv') && validateMealVoucherVrPreTokenizedCardCvv(userInputValue);

    default:
      return VALID;
  }
}

function validateMealVoucherVrPreTokenizedCardCvv(cvv: string): ?UserInputValidationError {
  if (!cvv || !cvv.trim()) {
    return { id: 'empty' };
  }
}
